import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setQueryParams } from "../../../store/actionCreators/queryParams";
import { requestRaces } from "../../../store/actionCreators/races";
import { useQuery } from "../../../hooks/useQuery";
import LeaderboardAndPrizepool from "../../LeaderboardAndPrizepool";
import { getLeaderboard, getOngoingRaces, isRacesLoading } from "../../../store/selectors";
import "./OngoingView.scss";
import Skeleton from "../../Skeleton";
import { isMobile } from "react-device-detect";
import Tabs from "../../Tabs/Tabs";
import { requestRacesLeaderboard, resetRacesLeaderboard } from "../../../store/actionCreators/racesLeaderboard";

const OngoingView = () => {
  const dispatch = useDispatch();
  const queries = useQuery();
  const races = useSelector(getOngoingRaces);
  const pending = useSelector(isRacesLoading);
  const [currentRace, setCurrentRace] = useState([]);
  const [offset, setOffset] = useState(0);
  const [raceId, setRaceId] = useState(0);
  const leaderboard = useSelector(getLeaderboard)(raceId);
  const limit = 100

  useEffect(() => {
    if (Object.keys(queries)?.length) {
      dispatch(requestRaces());
    }
  }, [Object.keys(queries)?.length]);

  useEffect(() => {
    if (pending || races.length === 0) return;

    const firstRace = races[0];
    const race = races.find((item) => item.id === raceId) || firstRace;

    setCurrentRace([race]);
    setRaceId(race?.id || firstRace?.id);
    window.parent?.parent.postMessage({ type: "RACE_ID", id: race.id }, "*");

  }, [races, pending, raceId]);

  const handleShowMore = useCallback(() => {
    if (pending) return;

    if (leaderboard?.length >= limit) {
      dispatch(requestRacesLeaderboard({raceId, limit, offset: offset + 100}));
      setOffset((prevOffset) => prevOffset + limit);
    }
  }, [raceId, limit, offset, pending, leaderboard?.length]);

  useLayoutEffect(() => {
    dispatch(setQueryParams(queries));
  }, [queries, dispatch]);

  const handleCurrentTableChange = useCallback((id) => {
    if (id !== +raceId) {
      dispatch(resetRacesLeaderboard());
      dispatch(requestRacesLeaderboard({ raceId: id, limit, offset: 0 }));
    }
    setOffset(0);
    setRaceId(id);
    const race = races.filter((item) => item.id === id);
    setCurrentRace(race);
  }, [races, raceId]);

  return (
      <div className="ongoing-view">
        {races?.length > 1 && (
            <div className="race-tab-switcher">
              {races?.map((item, index) => (
                  <Tabs
                      tabs={[{ label: item?.name, value: item?.id, prizePool: item?.prize_pool, currency: item?.currency, imgSrc: item?.img_url }]}
                      selectedTab={currentRace?.[0]?.id}
                      variant="secondary"
                      onChange={handleCurrentTableChange}
                      backgroundColor="var(--BG-Surface-3, #2E3138)"
                      key={index}
                      isMultipleRace={true}
                  />
              ))}
            </div>
        )}
        {pending ? (
            <Skeleton
                radius={8}
                width={isMobile ? '100%' : 771}
                height={isMobile ? 655 : 693}
                style={{ display: "flex", justifyContent: "center" }}
            />
        ) : (
            currentRace?.length > 0 &&
            currentRace?.map((item) => (
                <div
                    key={item?.id}
                    className="ongoing-view__leaderboard-and-prizepool-wrapper"
                >
                  <LeaderboardAndPrizepool item={item} handleShowMore={handleShowMore} />
                </div>
            ))
        )}
      </div>
  );
};

export default OngoingView;
